module.exports = __webpack_public_path__ + "img/logo.9c555c6.svg";